import { useSearchParams } from 'react-router-dom';

export type IngestionDetailTab =
  | 'overview'
  | 'parsing'
  | 'validation'
  | 'assessments'
  | 'records'
  | 'diagnostics';

export const INGESTION_DETAIL_TABS: IngestionDetailTab[] = [
  'overview',
  'parsing',
  'validation',
  'assessments',
  'records',
  'diagnostics',
];

export const DEFAULT_INGESTION_DETAIL_TAB: IngestionDetailTab = 'overview';

const TAB_SEARCH_PARAM = 'tab';

const isIngestionDetailTab = (
  value: string | null,
): value is IngestionDetailTab =>
  value !== null && INGESTION_DETAIL_TABS.includes(value as IngestionDetailTab);

export interface UseDetailTabResult {
  activeTab: IngestionDetailTab;
  setActiveTab: (tab: IngestionDetailTab) => void;
}

/**
 * URL-driven sub-tab state via the `?tab=` search param, so a tab can be
 * deep-linked or shared. Falls back to the default tab for missing or
 * unrecognized values.
 */
export const useDetailTab = (): UseDetailTabResult => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get(TAB_SEARCH_PARAM);
  const activeTab = isIngestionDetailTab(rawTab)
    ? rawTab
    : DEFAULT_INGESTION_DETAIL_TAB;

  const setActiveTab = (tab: IngestionDetailTab): void => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set(TAB_SEARCH_PARAM, tab);
    setSearchParams(nextParams);
  };

  return { activeTab, setActiveTab };
};
